import { theme } from "antd";
import { Children, CSSProperties, PropsWithChildren } from "react";
import { Flex } from "src/components/Flex";

export const ActionCard = (
  props: PropsWithChildren<{
    badge: React.ReactElement;
    label: string | React.ReactElement;
    value: React.ReactElement;
  }>
) => {
  const { token } = theme.useToken();
  const cardStyle: CSSProperties = {
    width: "100%",
    backgroundColor: token.colorBgLayout,
    borderRadius: 10,
    padding: 16,
    fontSize: 14,
    color: token.colorTextSecondary,
  };

  const childCount = Children.count(props.children);

  return (
    <div style={cardStyle}>
      <Flex gap={4} style={{ marginBottom: 8 }}>
        {props.badge}
        <h3
          style={{
            flex: 1,
            margin: 0,
            color: token.colorText,
          }}
        >
          {props.label}
        </h3>
        {childCount > 0 && <span>{props.value}</span>}
      </Flex>
      <div>{childCount > 0 ? props.children : props.value}</div>
    </div>
  );
};
